import React from 'react';
import { createPortal } from 'react-dom';
import './IncompleteFamilyMembersModal.css';

interface IncompleteFamilyMembersModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const IncompleteFamilyMembersModal: React.FC<IncompleteFamilyMembersModalProps> = ({
  isOpen,
  onClose
}) => {
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleOkayClick = () => {
    onClose();
  };

  console.log('🔍 IncompleteFamilyMembersModal: Render called with props:', { isOpen });
  
  if (!isOpen) {
    console.log('❌ IncompleteFamilyMembersModal: Not rendering - isOpen is false');
    return null;
  }

  console.log('✅ IncompleteFamilyMembersModal: Rendering modal - isOpen is true');

  const modalContent = (
    <div className="incomplete-family-modal-backdrop" onClick={handleBackdropClick}>
      <div className="incomplete-family-modal-container">
        <div className="incomplete-family-modal-content">
          <div className="incomplete-family-modal-card">
            {/* Modal Header */}
            <div className="incomplete-family-modal-header">
              <h2 className="incomplete-family-modal-title">Before you continue..</h2>
              <button
                className="incomplete-family-modal-close"
                onClick={onClose}
                aria-label="Close modal"
              >
                ×
              </button>
            </div>

            {/* Modal Body */}
            <div className="incomplete-family-modal-body">
              <div className="incomplete-family-modal-message">
                <p>
                  Our Family Plan is ideal if there are at least three (3) persons traveling in a Family (e.g. husband and wife plus one child or one parent plus two children)..
                <br/><br/>If you wish to insure two adults, please get our Single Trip Individual Plan instead.
                </p>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="incomplete-family-modal-footer">
              <button
                className="incomplete-family-modal-okay-btn"
                onClick={handleOkayClick}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // Render modal using React portal to ensure it's rendered at document body level
  return createPortal(modalContent, document.body);
};

export default IncompleteFamilyMembersModal;